import { render, staticRenderFns } from "./Createdecs.vue?vue&type=template&id=207ccf76&scoped=true"
import script from "./Createdecs.vue?vue&type=script&lang=js"
export * from "./Createdecs.vue?vue&type=script&lang=js"
import style0 from "./Createdecs.vue?vue&type=style&index=0&id=207ccf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ccf76",
  null
  
)

export default component.exports